/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_SubscriptionInputs */



/**
* | output |
* | --- |
* | "Manage Subscription" |
*
* @param {Manage_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manage_subscription = /** @type {((inputs?: Manage_SubscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_SubscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer l'abonnement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement verwalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci abbonamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление подпиской")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrar suscripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理订阅")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションの管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता प्रबंधित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciar assinatura")
	return /** @type {LocalizedString} */ ("Manage Subscription")
});